import { render, staticRenderFns } from "./NovoCliente.vue?vue&type=template&id=3679d614&"
import script from "./NovoCliente.vue?vue&type=script&lang=js&"
export * from "./NovoCliente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports